'use client'
import SearchIcon from '../../icons/SearchIcon'
import InputField from '../FormFields/InputField/index'
import * as Yup from 'yup'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Button from '../Button/index'
import * as React from 'react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import routes from 'web/src/lib/routes'

const schema = Yup.object({
    searchQuery: Yup.string().min(1).required('Please fill in a search term.'),
})

const SearchForm = () => {
    const methods = useForm({ resolver: yupResolver(schema) })
    const searchQuery = methods?.watch('searchQuery')
    const router = useRouter()
    const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = e => {
        if (e.keyCode === 13 && e.currentTarget.value) {
            router.push(routes.search.replace(':zoekterm', searchQuery))
        }
    }

    return (
        <FormProvider {...methods}>
            <InputField
                onKeyDown={handleKeyDown}
                className="max-w-[220px]"
                placeholder="Zoeken..."
                id="searchQuery"
                type="text"
                {...methods.register('searchQuery')}
            />
            <Button
                //@ts-ignore
                as={Link}
                href={searchQuery ? routes.search.replace(':zoekterm', searchQuery) : '#'}
                variant="primary"
                className="max-w-[56px] hover:animate-none hover:bg-none hover:text-white hover:transition-none"
            >
                <SearchIcon />
            </Button>
        </FormProvider>
    )
}

export default SearchForm
